<template>
  <div class="animated fadeIn fkirim">
    <b-row class="justify-content-center" >
      <b-col md="11" lg="9" xl="5">
        <b-card>
          <div slot="header">{{$route.meta.label}}</div>
            <b-input-group>
              <b-input-group-prepend>
                <label>Tanggal Kirim</label>
              </b-input-group-prepend>
              <b-form-input
                class="col-md-6"
                v-model="model.tanggal"
                type="date"
                :state="!$v.model.tanggal.$error"
              ></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Agen / Customer</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="customer_info"
                placeholder="Cari kode atau nama agen."
                readonly
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              <b-input-group-append>
                <b-btn text="Button" @click="clearCust">
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>

            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jurusan</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="jurusan_info"
                placeholder="Kunci pencarian dengan nama,kode jurusan"
                readonly
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranJurusan" @click="lkuKoranJurusanShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranJurusan" @click="clearJurusan">
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>

            </b-input-group>
            <b-card
              header="List Faktur Yang Tidak Dapat Dititipkan."
              class="report-wraper"
              v-show="showTableKirimTitipan"
            >
              <b-table
                class="mb-0 my-table-scroll"
                ref="table"
                outlined
                hover
                style="font-size:smaller;"
                :fields="tblFields"
                :items="tblData.items"
                :current-page="tblData.page"
                :per-page="tblData.limit"
                :sort-by.sync="tblData.sortBy"
                :sort-desc.sync="tblData.sortDesc"
                :key="tblData.limit"
                @row-clicked="rowClicked"
              >
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
              </b-table>
              <b-row class="mt-2">
                <b-col cols="4">
                  <div>
                    Showing
                    {{(tblData.page - 1) * tblData.limit + 1}}
                    to
                    {{tblData.page * tblData.limit}}
                    of
                    {{tblData.total}}
                    entries
                  </div>
                </b-col>
                <b-col cols="4">
                  <b-form-group label-cols="3" label="Limit per page" class="mb-0">
                    <b-form-select
                      :options="[10, 20, 30, 50, 70, 90, 120]"
                      :plain="true"
                      v-model="tblData.limit"
                      style="width:80px;"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    align="right"
                    :total-rows="tblData.total"
                    :per-page="tblData.limit"
                    v-model="tblData.page"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-card>
            <b-row class="justify-content-center mt-2">
              <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop.prevent="print()">
                <i class="fa fa-print"></i> Print
              </button>
              <b-button class="btn btn-primary mr-1" @click.stop.prevent="close()">
                <i class="fa fa-close"></i> Batal
              </b-button>
            </b-row>
        </b-card>
        </b-col>
    </b-row>

    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Agen/Langganan"
      :centered="true"
    >
      <lku-customerkoran customer_group='KORAN' @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
    <b-modal
      v-model="lkuKoranJurusanShow"
      size="lg"
      :hide-footer="true"
      title="List Jurusan Koran"
      :centered="true"
    >
      <lku-jurusan @click="onSelectKoranJurusan"></lku-jurusan>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>


<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import Loading from "vue-loading-overlay";
import crud from "../../apis/crud";
import koran_report from "../../apis/koran_report";
import koran_kiriman from "../../apis/koran_kirim_pesanan";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuJurusan from "../lookup/lkuKoranJurusan";

toastr.init();

export default {
  components: { Loading, lkuCustomerkoran, lkuJurusan },
  mixins: [validationMixin],
  validations: {
    model: {
      tanggal: { required }
    }
  },
  data() {
    return {
      isLoading: false,
      saveEnabled: true,
      lkuKoranCustShow: false,
      lkuKoranJurusanShow: false,
      showTableKirimTitipan: false,
      model: {
        tanggal: null,
        customer_id: null,
        jurusan_id: null,
        isPrintedForm: "nonPrinted"
      },
      customer_info: null,
      jurusan_info: null,
      tblData: {
        tanggal: null,
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "modified",
        sortDesc: false
      },
      showReport: false,
      reportUrl: null
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields() {
      const fields = [
        { key: "index", label: "No.", thStyle: "width:40px" },
        // {
        //   key: "CustCode",
        //   label: "Cust. Code"
        // },
        {
          key: "CustName",
          label: "Cust Name"
        },
        {
          key: "jurusan_code",
          label: "Kode Jurusan"
        },
        {
          key: "jurusan_name",
          label: "Jurusan"
        },
        {
          key: "percetakan_name",
          label: "Nama Percetakan"
        },
        {
          key: "totkirim",
          label: "Jumlah Cetak"
        }
      ];
      return fields;
    }
  },
  watch: {},
  created: async function() {},
  methods: {
    // iframeDidLoad() {
    //   alert("Done");
    // },
    clearCust() {
      this.model.cutomer_id = null;
      this.customer_info = null;
    },
    clearJurusan() {
      this.model.jurusan_id = null;
      this.jurusan_info = null;
    },

    onSelectKoranCust(_selected) {
      this.customer_info = `${_selected.CustCode + " | " + _selected.CustName}`;
      this.model.customer_id = _selected.customer_id;
      this.lkuKoranCustShow = false;
    },
    onSelectKoranJurusan(_selected) {
      this.jurusan_info = `${_selected.jurusan_code +
        " | " +
        _selected.jurusan_name}`;
      this.model.jurusan_id = _selected.jurusan_id;
      this.lkuKoranJurusanShow = false;
    },
    data: async function() {
      let list = [];
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery = "";
      let str;
      if (this.model.tanggal !== null) {
        str += str ? "&" : "";
        str = "tanggal=" + encodeURIComponent(this.model.tanggal);
        this.tblData.customQuery = str;
        list = await crud.list(this.tblData);
        return list;
      } else {
        return list;
      }
    },
    print: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.isLoading = true;
          this.reportUrl = null;
          this.showReport = true;
          console.log("this.model", this.model);
          this.reportUrl = await koran_report.fakturKirimMIPrint(this.model);
          this.isLoading = false;
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    rowClicked: function() {},
    async getDataPesanan(kirimanKeys) {
      try {
        kirimanKeys.push("ac20d50d-f310-11e9-a932-07af56a22aeb");
        const resp = await koran_kiriman.list({ kirimanKeys });
        this.showTableKirimTitipan = true;

        this.tblData.items = resp;
      } catch (error) {
        console.log("getDataPesanan error", error);
      }
    },
    // refresh(ctx) {
    //   if (this.$refs.table) this.$refs.table.refresh();
    // },
    close() {
      // if (this.$store.state.prevRoute.name) {
      //   router.push({ name: this.$store.state.prevRoute.name });
      // } else {
      //   router.push({ name: "koran.customer" });
      // }
      router.push({ name: "koran.home" });
    },
    clearModel() {}
  }
};
</script>